import client from './client';

/**
 * @typedef {import('axios').AxiosResponse} AxiosResponse
 */

/**
 * @typedef {Object} CurrentUser
 */

const URL = 'current-user/';

const fetchCurrentUser = async () => {
  return client.get(URL);
};

const URL_UPDATE = 'update-user/';

const updateCurrentUser = async (password: string, studio: string) => {
  client.put(URL_UPDATE, {
    'password': password,
    'studio': studio,
  });
};

const updateCurrentPassword = async (password: string) => {
  client.put(URL_UPDATE, {
    'password': password,
  });
};

const updateCurrentStudio = async (studio: string) => {
  client.put(URL_UPDATE, {
    'studio': studio,
  });
};

const actions = {
  fetchCurrentUser,
  updateCurrentUser,
  updateCurrentPassword,
  updateCurrentStudio,
};

export default actions;
